const debug = (message: any) => {
  (window as any)?.DD_LOGS?.logger?.error(message);
  if (process.env.NODE_ENV === "development") {
    console.log(message);
  }
};

const Logger = { debug };
export default Logger;
